import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  private exportTrigger = new Subject<void>();
  private exportingState = new Subject<boolean>();

  exportTrigger$ = this.exportTrigger.asObservable();
  exportingState$ = this.exportingState.asObservable();

  triggerExport(): void {
    this.exportTrigger.next();
  }

  setExporting(value: boolean): void {
    this.exportingState.next(value);
  }
}
